import { connect } from "react-redux";
import { useState } from "react";
import { mapStateToProps } from "../../store/helpers/mapState";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch";
import React, { useEffect } from "react";
import DatatableComponent from "../../helpers/DatatableComponent";
import moment from "moment";
import DeleteDialog from "../../helpers/DeleteDialog";
import { useHistory, useParams } from "react-router";
import StatusLayout from "components/Status";
import {
  Typography,
} from "@mui/material";
import {
  FaArrowLeft,
  FaUser,
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
  FaProjectDiagram,
  FaMoneyBillWave,
} from "react-icons/fa";

function PartnerProjects({ location, SetSelectedMenu }) {
  const [open, setOpen] = useState(0);
  const [value, setValue] = useState({});
  const [list, setList] = useState([]);
  const [activityList, setActivityList] = useState([]);
  const [id, setId] = useState();
  const [partnerInfo, setPartnerInfo] = useState(
    location.state?.partner || null
  );

  const [count, setCount] = useState(0);

  const [deleteOpen, setDeleteOpen] = useState(false);

  const { id: partnerId } = useParams();

  const history = useHistory();

  useEffect(() => {
    SetSelectedMenu({
      menu: "partner",
      title: "Partners Management",
    });
    setPartnerInfo(location.state?.partner || null);
  }, [partnerId, location.state]);

  const columns = [
    {
      name: "code",
      label: "Code",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <span className="text-custom-blue text-xs ">{value}</span>
        ),
      },
    },
    {
      name: "name",
      label: "Name",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <span className="text-custom-blue text-xs ">{value}</span>
        ),
      },
    },
    {
      name: "startDate",
      label: "Start Date",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <span className="text-[#A1A1A1] text-xs">
            {moment(value).format("DD/MM/yyyy") ?? ""}
          </span>
        ),
      },
    },
    {
      name: "endDate",
      label: "End Date",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <span className="text-[#A1A1A1] text-xs">
            {moment(value).format("DD/MM/yyyy") ?? ""}
          </span>
        ),
      },
    },
    {
      name: "budget",
      label: "Budget",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <span className="text-[#A1A1A1] text-xs font-lighter">{value}</span>
        ),
      },
    },
    {
      name: "PartnerAssignments",
      label: "Allocated Amount",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => {
          const amount = value?.reduce(
            (acc, curr) => acc + parseFloat(curr?.amount),
            0
          );
          return (
            <span className="text-[#A1A1A1] text-xs font-lighter">
              {amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
            </span>
          );
        },
      },
    },
    {
      name: "PartnerAssignments",
      label: "Spent",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => {
          const receivedAmount = value?.reduce(
            (acc, curr) => acc + parseFloat(curr?.receivedAmount),
            0
          );
          return (
            <span className="text-[#A1A1A1] text-xs font-lighter">
              {receivedAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
            </span>
          );
        },
      },
    },
    {
      name: "id",
      label: "Balance",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => {
          const partner = list.find((x) => x.id === value);
          const receivedAmount = partner?.PartnerAssignments?.reduce(
            (acc, curr) => acc + curr?.receivedAmount,
            0
          );
          const allocatedAmount = partner?.PartnerAssignments?.reduce(
            (acc, curr) => acc + curr?.amount,
            0
          );
          return (
            <span className="text-custom-blue text-xs ">
              {(allocatedAmount - receivedAmount)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
            </span>
          );
        },
      },
    },
  ];

  const ActivityColumns = [
    {
      name: "name",
      label: "Name",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <span className="text-custom-blue text-xs ">{value}</span>
        ),
      },
    },
    {
      name: "startDate",
      label: "Start Date",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <span className="text-[#A1A1A1] text-xs">
            {moment(value).format("DD/MM/yyyy") ?? ""}
          </span>
        ),
      },
    },
    {
      name: "endDate",
      label: "End Date",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <span className="text-[#A1A1A1] text-xs">
            {moment(value).format("DD/MM/yyyy") ?? ""}
          </span>
        ),
      },
    },
    {
      name: "partners",
      label: "Partner Type",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => {
          const partnerType = value?.map((x) => x.partnerType).join(", ");
          return <span className="text-[#A1A1A1] text-xs">{partnerType}</span>;
        },
      },
    },
    {
      name: "partners",
      label: "Allocated Amount",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => {
          const amount = value?.reduce(
            (acc, curr) => parseFloat(acc) + parseFloat(curr?.amount),
            0
          );
          return (
            <span className="text-[#A1A1A1] text-xs font-lighter">
              {amount}
            </span>
          );
        },
      },
    },
    {
      name: "partners",
      label: "Spent",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => {
          const receivedAmount = value?.reduce(
            (acc, curr) => acc + curr?.receivedAmount,
            0
          );
          return (
            <span className="text-[#A1A1A1] text-xs font-lighter">
              {receivedAmount}
            </span>
          );
        },
      },
    },
    {
      name: "id",
      label: "Balance",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => {
          const activity = activityList.find((x) => x.id === value);
          const receivedAmount = activity?.partners?.reduce(
            (acc, curr) => acc + curr?.receivedAmount,
            0
          );
          const allocatedAmount = activity?.partners?.reduce(
            (acc, curr) => acc + curr?.amount,
            0
          );
          return (
            <span className="text-custom-blue text-xs ">
              {allocatedAmount - receivedAmount}
            </span>
          );
        },
      },
    },
    {
      name: "status",
      label: "Status",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (status) => {
          return (
            <span style={{ fontSize: "0.85rem" }}>
              <StatusLayout status={status} />
            </span>
          );
        },
      },
    },
    {
      name: "impact",
      label: "Impact",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <span className="text-[#A1A1A1] text-xs font-lighter">{value}</span>
        ),
      },
    },
  ];

  const setValue0 = (name, val) => {
    if (!name) {
      return null;
    }

    setValue((v) => {
      v[name] = val;
      return { ...v };
    });
  };
  const onSuccess = () => {
    setCount((v) => v + 1);
  };

  return (
    <div className="w-full mb-12 px-4">
      <DeleteDialog
        open={deleteOpen}
        setOpen={() => setDeleteOpen(false)}
        onSuccess={onSuccess}
        url={`/api/partner/delete/${id}`}
      />

      <div className="w-full">
        <div className="p-6 bg-white border border-gray-200 rounded-lg shadow-sm flex flex-col gap-4 mb-4">
          <div
            onClick={() => history.push("/admin/partners")}
            className="text-gray-500 flex items-center gap-2 cursor-pointer"
          >
            <FaArrowLeft />
            <span className="font-semibold">{partnerInfo?.name}</span>
          </div>

          {!partnerInfo ? (
            <div className="flex justify-center items-center p-6">
              <Typography>No partner information available</Typography>
            </div>
          ) : (
            <div className="p-6 bg-white border border-gray-200 rounded-lg shadow-sm">
              <div className="grid grid-cols-3 gap-4">
                <div className="space-y-4">
                  <div className="space-y-2">
                    <p className="text-gray-500 font-light flex items-center gap-2">
                      <FaUser /> Representative
                    </p>
                    <p className="font-semibold">
                      {partnerInfo.representative || "N/A"}
                    </p>
                  </div>
                  <div className="space-y-2">
                    <p className="text-gray-500 font-light flex items-center gap-2">
                      <FaMapMarkerAlt /> Address
                    </p>
                    <p className="font-semibold">
                      {partnerInfo.address || "N/A"}
                    </p>
                  </div>
                </div>

                <div className="space-y-4">
                  <div className="space-y-2">
                    <p className="text-gray-500 font-light flex items-center gap-2">
                      <FaEnvelope /> Contact Email
                    </p>
                    <p className="font-semibold">
                      {partnerInfo.email || "N/A"}
                    </p>
                  </div>
                  <div className="space-y-2">
                    <p className="text-gray-500 font-light flex items-center gap-2">
                      <FaPhone /> Contact Phone
                    </p>
                    <p className="font-semibold">
                      {partnerInfo.phone || "N/A"}
                    </p>
                  </div>
                </div>

                <div className="space-y-4">
                  <div className="space-y-2">
                    <p className="text-gray-500 font-light flex items-center gap-2">
                      <FaProjectDiagram /> Total Projects
                    </p>
                    <p className="font-semibold">
                      {partnerInfo.projects || "0"}
                    </p>
                  </div>
                  <div className="space-y-2">
                    <p className="text-gray-500 font-light flex items-center gap-2">
                      <FaMoneyBillWave /> Financial Summary
                    </p>
                    <div className="flex gap-3">
                      <div>
                        <p className="text-gray-500 text-xs">Allocated:</p>
                        <p className="font-semibold">
                          {partnerInfo.totalAmount
                            ? partnerInfo.totalAmount
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            : "0"}
                        </p>
                      </div>
                      <div>
                        <p className="text-gray-500 text-xs">Spent:</p>
                        <p className="font-semibold">
                          {partnerInfo.receivedAmount
                            ? partnerInfo.receivedAmount
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            : "0"}
                        </p>
                      </div>
                      <div>
                        <p className="text-gray-500 text-xs">Balance:</p>
                        <p className="font-semibold">
                          {partnerInfo.totalAmount && partnerInfo.receivedAmount
                            ? (
                              partnerInfo.totalAmount -
                              partnerInfo.receivedAmount
                            )
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            : "0"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <DatatableComponent
        processData={(data) => {
          setList(data.data);
          return data;
        }}
        onRowSelectionChange={(list) => { }}
        expandableRows={true}
        renderExpandableRow={(rowData, rowMeta) => {
          const partner = list[rowMeta.dataIndex];
          const activities = partner?.activities;
          setActivityList(activities);
          return (
            <tr>
              <td colSpan={12}>
                <div className="w-full p-10">
                    <DatatableComponent
                      initialData={activities}
                      onRowSelectionChange={(list) => { }}
                      elevation={1}
                      pdf={false}
                      excel={false}
                      url={"/api/partner/activities/"+partner.id}
                      columns={ActivityColumns}
                      viewColumns={false}
                      searchfield={false}
                      search={false}
                      title={"All Activities"}
                    />
                </div>
              </td>
            </tr>
          );
        }}
        elevation={1}
        pdf={false}
        excel={false}
        columns={columns}
        viewColumns={false}
        searchfield={true}
        search={false}
        url={`/api/partner/projects/${partnerId}?count=${count}`}
        title={"Assigned Projects"}
      />
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(PartnerProjects);
